var _rect, _rect2, _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCircleCheckIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    width: 47,
    height: 47,
    rx: 23.5,
    fill: "url(#circle-check-icon_svg__paint0_linear)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.065,
    y: 5.306,
    width: 35.629,
    height: 35.629,
    rx: 17.814,
    fill: "url(#circle-check-icon_svg__paint1_linear)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.091 30.645c-.4 0-.8-.147-1.105-.44l-5.528-5.319a1.464 1.464 0 010-2.127c.61-.588 1.6-.588 2.21 0l4.423 4.255 9.95-9.573c.61-.588 1.6-.588 2.21 0 .611.587.611 1.54 0 2.127L22.198 30.205c-.306.293-.706.44-1.106.44z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "circle-check-icon_svg__paint0_linear",
    x1: 23.5,
    y1: 0,
    x2: 23.5,
    y2: 47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8FDEA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6DCFAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "circle-check-icon_svg__paint1_linear",
    x1: 23.879,
    y1: 5.306,
    x2: 23.879,
    y2: 40.935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8FDEA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6DCFAE"
  })))));
}

export default __webpack_public_path__ + "./fonts/circle-check-icon.1edff17f562983ee927283d50d51100a.svg";
export { SvgCircleCheckIcon as ReactComponent };